import { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TaskCard } from "@/components/TaskCard";
import { api } from "@/lib/api";

export default function MyTasks() {
  const [tasks, setTasks] = useState([]);
  const [tab, setTab] = useState("open");

  useEffect(() => {
    api.get("/tasks").then((r) => setTasks(r.data));
  }, []);

  const shown = tasks.filter((t) => (tab === "open" ? ["assigned", "in_progress", "pending_spares"].includes(t.status) : ["completed", "cancelled"].includes(t.status)));

  return (
    <div className="space-y-5">
      <h1 className="font-heading text-3xl font-extrabold text-slate-900 tracking-tight">My Tasks</h1>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="grid grid-cols-2 w-full">
          <TabsTrigger value="open" data-testid="my-tasks-tab-open">Active</TabsTrigger>
          <TabsTrigger value="done" data-testid="my-tasks-tab-done">Completed</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="space-y-3" data-testid="my-tasks-list">
        {shown.length === 0 && <div className="text-sm text-slate-500 bg-white border border-dashed rounded-xl p-6 text-center">Nothing here.</div>}
        {shown.map((t, i) => <TaskCard key={t.id} t={t} i={i} />)}
      </div>
    </div>
  );
}
